import React, { FC } from "react";
import { useCompletionsQuery } from "../queries/completion-queries";
import { Navbar, Container, Table } from "react-bootstrap";
import { categoryImgs } from "../types/Category";
import { Coins } from "./coins";
import { Completion } from "../types/Completion";
import { useMissions } from "../queries/mission-queries";

export const CompHistory: FC = () => {
    const { completions } = useCompletionsQuery();
    const { oneshotMissions, repeatingMissions } = useMissions()

    const missions = [...oneshotMissions, ...repeatingMissions]

    const findMissionName = (id: string) => {
        const mission = missions.find(mission => mission.id === id)
        return mission?.title || 'Unknown'
    }

    return (
        <>
            <Navbar sticky="top" key={'nav-bar'} expand={false} className="bg-body-secondary mb-3">
                <Container fluid>
                    <h2 className="mb-0">History</h2>
                </Container>
            </Navbar>
            <Table>
                <thead>
                    <tr>
                        <th className="text-start">Name</th>
                        <th className="text-end">Reward</th>
                        <th className="text-end">Days left</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {completions?.map((comp: Completion, index) => (
                        <tr key={index}>
                            <td className="text-start">{findMissionName(comp.missionId)}</td>
                            <td className="text-end"><Coins coins={comp.coins} fontSize={6} size={11} /></td>
                            <td className="text-end">{comp.date.toLocaleString()}</td>
                            <td>
                                <img
                                    src={categoryImgs[comp.category]}
                                    width="15"
                                    height="15"
                                    className="d-inline-block align-top"
                                    alt={comp.category}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </>
    )
}